// extracted by mini-css-extract-plugin
export var aircallIframe = "_n2-3";
export var fabContainer = "_n2-5";
export var fabRinging = "_n2-6";
export var loadingOverlay = "_n2-4";
export var pulse = "_n2-7";
export var widgetContent = "_n2-2";
export var widgetPanel = "_n2-0";
export var widgetPanelExpanded = "_n2-1";